import { cn } from '@/lib/cn';
import { Button } from './Button';

/** לכל מסך שלושת המצבים, בטון חם (מסמך התכנון, סעיף 8.3). */

export function EmptyState({
  title = 'אין כאן כלום כרגע',
  description = 'הכל מעודכן.',
  className,
}: {
  title?: string;
  description?: string;
  className?: string;
}) {
  return (
    <div className={cn('grid gap-1 p-8 text-center', className)}>
      <p className="m-0 font-display text-display-m font-semibold">{title}</p>
      <p className="m-0 text-body text-muted">{description}</p>
    </div>
  );
}

export function ErrorState({
  description = 'משהו השתבש. נסו שוב.',
  onRetry,
  className,
}: {
  description?: string;
  onRetry?: () => void;
  className?: string;
}) {
  return (
    <div className={cn('grid justify-items-center gap-3 p-8 text-center', className)}>
      <p className="m-0 text-body text-ink">{description}</p>
      {onRetry && (
        <Button variant="secondary" onClick={onRetry}>
          נסה שוב
        </Button>
      )}
    </div>
  );
}

export function Skeleton({ className }: { className?: string }) {
  return (
    <div
      aria-hidden="true"
      className={cn('animate-pulse rounded-md bg-olive-soft', className)}
    />
  );
}

export function LoadingScreen({ label = 'טוען' }: { label?: string }) {
  return (
    <div role="status" aria-live="polite" className="grid min-h-dvh place-items-center bg-cream">
      <span className="sr-only">{label}</span>
      <div className="grid w-full max-w-sm gap-3 p-4">
        <Skeleton className="h-6 w-1/2" />
        <Skeleton className="h-28 w-full" />
        <Skeleton className="h-28 w-full" />
      </div>
    </div>
  );
}
